module.exports = __webpack_public_path__ + "static/media/food-chain-grapes-tablet.e7c256e0.jpg";